module.exports = __webpack_public_path__ + "static/media/icon.ab6738f9.svg";